import __request__ from "routing/request";
export function histogram(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/histogram/alerts", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportHistogram(JSONbody, filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/security_events/histogram/alerts/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
export function status(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/security_events/histogram/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function tacticsHistogram(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/histogram/tactics", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportTacticsHistogram(JSONbody, filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/security_events/histogram/tactics/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
export function techniquesHistogram(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/histogram/techniques", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportTechniquesHistogram(JSONbody, filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/security_events/histogram/techniques/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
